import * as React from "react";
import type { SVGProps } from "react";
const SvgAlma = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 24 24"
    width="100%"
    height="100%"
    {...props}
  >
    <path
      fill="#fa5022"
      fillRule="evenodd"
      d="M16.936 6.809C15.981 3.179 13.943 2 12 2S8.02 3.178 7.064 6.809L2.892 22H7c.287-1.115.924-2.134 1.815-2.834.892-.733 2.007-1.115 3.185-1.115s2.261.382 3.185 1.115c.891.732 1.56 1.72 1.815 2.834h4.108zM12 14.516a5.1 5.1 0 0 0-3.376 1.306l2.357-8.854c.223-.86.573-1.114 1.019-1.114s.796.254 1.02 1.114l2.356 8.854A4.93 4.93 0 0 0 12 14.516"
      clipRule="evenodd"
    />
  </svg>
);
export default SvgAlma;
